import {
  FaArrowPointer,
  FaArrowsRotate,
  FaCreditCard,
  FaDiagramProject,
  FaHandshake,
  FaHeart,
  FaListCheck,
  FaPlug,
  FaRoute,
  FaTableColumns,
  FaUsers,
} from 'react-icons/fa6'
import {
  SiAmazonwebservices,
  SiBrevo,
  SiClaude,
  SiCss3,
  SiFastify,
  SiFirebase,
  SiFlutter,
  SiGit,
  SiGooglemaps,
  SiHeroku,
  SiHtml5,
  SiJavascript,
  SiJira,
  SiLaravel,
  SiMongodb,
  SiMysql,
  SiNetlify,
  SiNewrelic,
  SiNextdotjs,
  SiNodedotjs,
  SiOpenai,
  SiPhp,
  SiPostgresql,
  SiPwa,
  SiPython,
  SiRazorpay,
  SiReact,
  SiSendgrid,
  SiSentry,
  SiStripe,
  SiSupabase,
  SiTwilio,
  SiVercel,
} from 'react-icons/si'

// logo + brand colour per skill; skills without a brand logo get a fitting icon
const skillIcons = {
  React: { Icon: SiReact, color: '#61dafb' },
  'Next.js': { Icon: SiNextdotjs, color: '#ffffff' },
  PWA: { Icon: SiPwa, color: '#a78bfa' },
  Flutter: { Icon: SiFlutter, color: '#47c5fb' },
  HTML5: { Icon: SiHtml5, color: '#e34f26' },
  CSS3: { Icon: SiCss3, color: '#2965f1' },
  JavaScript: { Icon: SiJavascript, color: '#f7df1e' },
  'Node.js': { Icon: SiNodedotjs, color: '#68a063' },
  Fastify: { Icon: SiFastify, color: '#ffffff' },
  Laravel: { Icon: SiLaravel, color: '#ff2d20' },
  PHP: { Icon: SiPhp, color: '#8993be' },
  Python: { Icon: SiPython, color: '#4b8bbe' },
  'REST APIs': { Icon: FaPlug, color: '#00ff7f' },
  Microservices: { Icon: FaDiagramProject, color: '#00ff7f' },
  MongoDB: { Icon: SiMongodb, color: '#47a248' },
  MySQL: { Icon: SiMysql, color: '#4479a1' },
  PostgreSQL: { Icon: SiPostgresql, color: '#6b9bd2' },
  Supabase: { Icon: SiSupabase, color: '#3ecf8e' },
  AWS: { Icon: SiAmazonwebservices, color: '#ff9900' },
  Vercel: { Icon: SiVercel, color: '#ffffff' },
  Netlify: { Icon: SiNetlify, color: '#00c7b7' },
  Heroku: { Icon: SiHeroku, color: '#a38bd6' },
  Git: { Icon: SiGit, color: '#f05032' },
  Sentry: { Icon: SiSentry, color: '#a78bfa' },
  'New Relic': { Icon: SiNewrelic, color: '#1ce783' },
  Stripe: { Icon: SiStripe, color: '#635bff' },
  Razorpay: { Icon: SiRazorpay, color: '#3395ff' },
  Telr: { Icon: FaCreditCard, color: '#ffd700' },
  Cardknox: { Icon: FaCreditCard, color: '#ff4500' },
  Twilio: { Icon: SiTwilio, color: '#f22f46' },
  SendGrid: { Icon: SiSendgrid, color: '#1a82e2' },
  Brevo: { Icon: SiBrevo, color: '#0b996e' },
  Firebase: { Icon: SiFirebase, color: '#ffca28' },
  'Google Maps': { Icon: SiGooglemaps, color: '#34a853' },
  'Claude Code': { Icon: SiClaude, color: '#d97757' },
  Codex: { Icon: SiOpenai, color: '#ffffff' },
  Cursor: { Icon: FaArrowPointer, color: '#ffffff' },
  Lovable: { Icon: FaHeart, color: '#ff6b8b' },
  'Claude Co-work': { Icon: SiClaude, color: '#d97757' },
  Agile: { Icon: FaArrowsRotate, color: '#00ff7f' },
  Scrum: { Icon: FaUsers, color: '#00ff7f' },
  Kanban: { Icon: FaTableColumns, color: '#00ff7f' },
  Jira: { Icon: SiJira, color: '#2684ff' },
  'Azure Boards': { Icon: FaTableColumns, color: '#0078d4' },
  Roadmaps: { Icon: FaRoute, color: '#ffd700' },
  Mentoring: { Icon: FaUsers, color: '#ffd700' },
  Stakeholders: { Icon: FaHandshake, color: '#ffd700' },
}

export const skillIconFor = (skill) =>
  skillIcons[skill] || { Icon: FaListCheck, color: '#00ff7f' }

